import React from "react";
// import "./LegalNotice.css"; // Ajouter un fichier CSS si nécessaire
import SEO from "../SEO/SEO";

const LegalNotice = () => {
  return (
    <div>
      <SEO
        title="Legal Notice - RS Transports"
        description="Legal notice of RS Transports, including company details, contact information, intellectual property rights, personal data, and terms of service."
        keywords="RS Transports, legal notice, terms of service, privacy policy, company information"
      />

      <section id="legal-notice" className="py-5">
        <div className="container">
          <h1 className="text-center mb-4">Legal Notice</h1>

          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">1. Company Information</h2>
                  <p><strong>Company Name:</strong> GROUP RSTRANSPORT</p>
                  <p><strong>Legal Status:</strong> SAS</p>
                  <p><strong>Registered Office:</strong> 66 avenue des Champs-Elysées, Paris, Immeuble D, 75008 Paris</p>
                  <p><strong>SIRET / RCS Number:</strong> 984813501 RCS Paris</p>
                  <p><strong>Share Capital:</strong> 15.000,00 euros</p>
                </div>
              </div>
            </div>

            <div className="col-md-12 mb-4">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">2. Publication Manager</h2>
                  <p><strong>Name:</strong> Mr. Sivakuru BALASWARAN</p>
                  <p><strong>Email:</strong> <a href="mailto:contact@rstransports.com">contact@rstransports.com</a></p>
                </div>
              </div>
            </div>

            <div className="col-md-12 mb-4">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">3. Hosting Provider</h2>
                  <p><strong>Name:</strong> MJ</p>
                  <p><strong>Address:</strong> 1 allée des Poiriers, 95400 Villiers Le Bel</p>
                  <p><strong>Phone:</strong> +33 (0)1 34 38 05 02</p>
                </div>
              </div>
            </div>

            <div className="col-md-12 mb-4">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">4. Intellectual Property</h2>
                  <p>All content on this website (text, images, graphics) is freely accessible and is not subject to copyright restrictions.</p>
                  <p>There are no specific conditions for the use of website content.</p>
                </div>
              </div>
            </div>

            <div className="col-md-12 mb-4">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">5. Personal Data & Cookies</h2>
                  <p><strong>Use of Cookies:</strong> Yes, this website uses cookies to improve user experience.</p>
                  <p><strong>Privacy Policy:</strong> Included on this page.</p>
                  <p><strong>Personal Data Storage:</strong> No personal data is stored, except for reservation processing and payment. No credit card information is retained.</p>
                </div>
              </div>
            </div>

            <div className="col-md-12 mb-4">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">6. Terms of Service</h2>
                  <p>RS Transports provides airport transfer services between Paris, Disneyland, and various hotels. Reservations must be made in advance, and users are responsible for providing accurate information.</p>
                  <p>In case of delays, RS Transports will attempt to accommodate passengers, but cannot guarantee wait times beyond a reasonable period.</p>
                  <p><strong>Dispute Resolution:</strong> Any disputes arising from the use of this service shall be resolved amicably. If no agreement is reached, the matter will be referred to the competent courts in Paris.</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalNotice;
